import type { BoardTask, SignoffStatus } from "./board";

/** The Greenlight action a column-to-column drag represents. */
export type MoveAction = "accept" | "request_changes" | "reopen";

/** A drag that's been dropped and is being applied (drives the optimistic move). */
export type PendingMove = {
  task: BoardTask;
  from: SignoffStatus;
  to: SignoffStatus;
  action: MoveAction;
};

/**
 * The only column-to-column drags that map to a backend action. The decision
 * endpoints each guard on the source state, so e.g. accepted↔changes_requested
 * has no single action — those return null and the card snaps back.
 *
 * Archived tasks have no column on the live board, so nothing can be dragged
 * into or out of that state; the explicit source check keeps that true by
 * construction rather than by trusting the board never to render one.
 */
export function moveAction(
  from: SignoffStatus,
  to: SignoffStatus,
): MoveAction | null {
  if (from === to) return null;
  if (from === "pending_review" && to === "accepted") return "accept";
  if (from === "pending_review" && to === "changes_requested")
    return "request_changes";
  if (
    to === "pending_review" &&
    (from === "accepted" || from === "changes_requested")
  )
    return "reopen";
  return null;
}
